import { render } from "./Modal.vue?vue&type=template&id=681331f1"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Modal.vue?vue&type=style&index=0&id=681331f1&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script